// Extend the native SideDrawer for the Personal Shopper Drawer
class PersonalShopperDrawer extends SideDrawer {
  constructor() {
    super();
    // We are using the global overlay (from document.querySelector('.js-overlay'))
    // so we do not override this.overlay here.
  }
  
  // Override open() to include recalcGloboFormPanels after opening
  open(opener, elementToFocus, callback) {
    // Call the native open() method with a custom callback
    super.open(opener, elementToFocus, () => {
      // Delay to allow the drawer to render and compute dimensions correctly
      setTimeout(() => {
        this.recalcGloboFormPanels();
        // Dispatch a resize event if needed by other scripts
        window.dispatchEvent(new Event("resize"));
        if (typeof callback === "function") {
          callback();
        }
      }, 300); // Adjust delay as necessary
    });
  }

  // Function to recalculate the height of Globo Form panels after the drawer is visible
  recalcGloboFormPanels() {
    // Find all panels containers within the globo form inside this drawer
    const panelsContainers = this.querySelectorAll(".globo-formbuilder .panels");
    panelsContainers.forEach(panelsContainer => {
      // Get the current visible panel (assuming hidden panels have the "hidden" class)
      const currentPanel = panelsContainer.querySelector(".panel:not(.hidden)");
      if (currentPanel) {
        // Calculate the new height (offsetHeight + 2 as per the original logic)
        const newHeight = currentPanel.offsetHeight + 2;
        panelsContainer.style.height = newHeight + "px";
        console.log("Updated panels container height to", newHeight);
      }
    });
  }
  
  // Handler for Shopify Theme Editor section select event
  handleSectionSelect(evt) {
    // When the section that contains this drawer is selected, open the drawer.
    if (evt.target === this.closest('.shopify-section')) {
      this.open();
    }
  }
}

// Register the custom element
customElements.define('personal-shopper-drawer', PersonalShopperDrawer);

// After DOM is loaded, attach event listeners.
document.addEventListener("DOMContentLoaded", function () {
  const personalShopperDrawer = document.querySelector("#personal-shopper-drawer");
  
  // Open the drawer when an anchor link with href="#personal-shopper" is clicked.
  const openLinks = document.querySelectorAll('a[href^="#personal-shopper"]');
  openLinks.forEach(link => {
    link.addEventListener("click", function (evt) {
      evt.preventDefault(); // Prevent the default jump behavior
      personalShopperDrawer.open(link);
    });
  });
  
  // If in Shopify Theme Editor (design mode), attach a section select handler
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    personalShopperDrawer.sectionSelectHandler = personalShopperDrawer.handleSectionSelect.bind(personalShopperDrawer);
    document.addEventListener('shopify:section:select', personalShopperDrawer.sectionSelectHandler);
  }
});
